import React from 'react';

import { DataColumns, TagTable } from 'components/components';
import { VentureBuilderInfoProps } from 'types/ventureBuilders';
import NOT_SPECIFIED from 'utils/constants/display';

import './VentureBuilderInfo.scss';

const VentureBuilderInfo = ({ ventureBuilder }: VentureBuilderInfoProps) => {
  const items = [
    { label: 'Venture Builder', value: ventureBuilder.name || NOT_SPECIFIED },
    { label: 'Description', value: ventureBuilder.description || NOT_SPECIFIED },
    { label: 'Contact name', value: ventureBuilder.fullName || NOT_SPECIFIED },
    { label: 'Email', value: ventureBuilder.email || NOT_SPECIFIED },
    {
      label: 'Status',
      value: (
        <TagTable
          text={ventureBuilder.active ? 'Active' : 'Inactive'}
          color={ventureBuilder.active ? 'success' : 'error'}
        />
      ),
    },
  ];

  return (
    <div className="venture-builder-info">
      <DataColumns columns={items} />
    </div>
  );
};

export default VentureBuilderInfo;
